import { render, staticRenderFns } from "./CustomerPurchaseOrders.vue?vue&type=template&id=a5f77df0&lang=pug&"
import script from "./CustomerPurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerPurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPurchaseOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports